import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
const NotFoundPage = () => {
    const { t } = useTranslation();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
        }, children: [_jsx(Typography, { variant: "h2", gutterBottom: true, children: "404" }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: t('notFound.title') }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: t('notFound.description') })] }));
};
export default NotFoundPage;
